import script from "./Timetable.vue?vue&type=script&lang=ts&setup=true"
export * from "./Timetable.vue?vue&type=script&lang=ts&setup=true"

import "./Timetable.vue?vue&type=style&index=0&id=e2d2a456&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_3adea55ba6ae913f8a015974add4e384/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2d2a456"]])

export default __exports__